import { relations } from 'drizzle-orm';
import { boolean, index, integer, pgTable, serial, text, timestamp, uniqueIndex, varchar } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import { EVENT_TYPES, event } from './event';
import { webhookEndpoint } from './webhook-endpoint';

export const webhookConversation = pgTable(
  'webhook_conversation',
  {
    id: serial().primaryKey(),
    public_id: typeId('webhookConversation', 'public_id').notNull(),
    first_attempt: boolean().notNull(),
    endpoint_id: integer()
      .notNull()
      .references(() => webhookEndpoint.id, { onDelete: 'cascade' }),
    endpoint_public_id: typeId('webhookEndpoint', 'endpoint_public_id').notNull(),
    event_id: integer()
      .notNull()
      .references(() => event.id, { onDelete: 'cascade' }),
    event_public_id: typeId('event', 'event_public_id').notNull(),
    event_type: varchar({ length: 255 }).notNull().$type<(typeof EVENT_TYPES)[number]>(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    http_status: integer(),
    endpoint_url: text().notNull(),
    response_body: text(),
    latency_ms: integer(),
    queue_latency_ms: integer(),
    response_time_ms: integer(),
  },
  (t) => [
    uniqueIndex('webhook_conversation_public_id_uq').on(t.public_id),
    index('webhook_conversation_endpoint_created_at_idx').on(t.endpoint_id, t.created_at),
    index('webhook_conversation_endpoint_public_id_idx').on(t.endpoint_public_id),
    index('webhook_conversation_event_public_id_idx').on(t.event_public_id),
    index('webhook_conversation_event_id_idx').on(t.event_id),
    index('webhook_conversation_created_at_idx').on(t.created_at),
  ],
);

export const webhookConversationRelations = relations(webhookConversation, ({ one }) => ({
  endpoint: one(webhookEndpoint, {
    fields: [webhookConversation.endpoint_id],
    references: [webhookEndpoint.id],
  }),
  event: one(event, {
    fields: [webhookConversation.event_id],
    references: [event.id],
  }),
}));
